import { useMemo } from 'react'
import { Maybe } from 'types/graphqlTypes'
import { getTimeAgoShort } from 'utils/formatDatetime'
import { formatRate } from 'utils/formatRate'
import { useCarrierLaneHistoryQuery } from '../graphql/CarrierLaneHistory'

export interface IUseCarrierLaneHistoryState {
  loading: boolean
  carrierRateHistory: Maybe<string>
}

export interface IUseCarrierLaneHistoryProps {
  shipmentId: Maybe<string>
  carrierApplicationId: Maybe<string>
}

export const useCarrierLaneHistory = ({
  carrierApplicationId,
  shipmentId,
}: IUseCarrierLaneHistoryProps): IUseCarrierLaneHistoryState => {
  const { data, loading } = useCarrierLaneHistoryQuery({
    variables: {
      shipmentId: shipmentId || '',
      carrierApplicationId: carrierApplicationId || '',
    },
    skip: !shipmentId || !carrierApplicationId,
  })
  const { laneHistory } = data || {}
  const { lastRan, lastRate, totalRan } = laneHistory || {}

  const carrierRateHistory = useMemo(() => {
    const history = [
      ...(totalRan ? [`Ran ${totalRan}x`] : []),
      ...(lastRate ? [formatRate(lastRate)] : []),
      ...(lastRan ? [`${getTimeAgoShort(lastRan)}`] : []),
    ]
    return history.join(' · ')
  }, [lastRan, lastRate, totalRan])

  return {
    loading,
    carrierRateHistory,
  }
}
